const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as any;
    const data = module.default || module.translation;
    if (data) {
      if (!messages[lang]) {
        messages[lang] = { translation: {} };
      }
      messages[lang].translation = {
        ...messages[lang].translation,
        ...data
      };
    }
  }
});

export default messages;